const persistLogin = ({ type, login, token }) => {
  localStorage.setItem('accessLevel', type === '2' ? 'admin' : 'user');
  localStorage.setItem('isLoggedIn', login);
  localStorage.setItem('token', token);
};

export const createUserObject = (apiObject) => {
  const {
    containerId,
    createdAt,
    email,
    id,
    login,
    name,
    type,
    token,
    channelIds,
    isCreator,
    userCredit,
  } = apiObject;
  persistLogin({ type, login, token });
  return {
    userId: id,
    containerId,
    createdAt,
    email,
    isLoggedIn: login,
    fullName: name,
    accessLevel: type === '2' ? 'admin' : 'user',
    channelIds,
    isCreatorAdmin: isCreator,
    userCredit,
  };
};
